"use client";
import { jsx as c } from "react/jsx-runtime";
import { withCmsDataHandling as k } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import { resolveHost as h, resolveLink as n, resolveLogo as L } from "../../../helpers/index.js";
import { TextLink as m, Header as f } from "@ingeniorforeningen/figurine-core";
const d = (e, s) => {
  const p = h(e.contentType || "");
  return {
    localLinks: e.properties?.websiteMenu?.items.map((i) => {
      const o = n(i.content.properties?.link?.[0], s);
      return {
        logo: { href: "/", icon: L(p) },
        header: i.content.properties?.link ? o.text : i.content.properties?.header ?? "",
        readMore: i.content.properties?.readMoreLink ? n(i.content.properties.readMoreLink?.[0]) : "",
        href: i.content.properties?.link ? o.href : "",
        target: i.content.properties?.link ? o.target : "",
        items: i.content.properties?.linkList && i.content.properties.linkList.map((r) => {
          const l = r.children?.find((t) => t.title === r.title);
          if (r.url && !l) {
            const t = { ...r };
            delete t.children, r.children?.unshift(t);
          }
          return {
            ...!r.url && n(r, s),
            header: !r.url && r.title,
            links: r.children && r.children.map((t) => ({
              ...n(t, s)
            }))
          };
        })
      };
    }),
    breakingBannerContent: (e.properties?.breakingText || e.properties?.text) && /* @__PURE__ */ c(
      m,
      {
        href: e.properties?.breakingLink && n(e.properties?.breakingLink?.[0])?.href,
        text: e.properties?.breakingText || e.properties?.text,
        variant: "inline"
      }
    ),
    actionLink: e.properties?.signUpLink ? n(e.properties.signUpLink?.[0]) : e.properties?.selfServiceLink && n(e.properties.selfServiceLink?.[0]),
    search: e.properties?.searchLink && n(e.properties.searchLink?.[0])
  };
}, M = k({
  Component: f,
  deliveryApiParser: d
});
export {
  M as Header,
  d as deliveryApiHeaderParser
};
